export type BrowserStorageKeys = string;

export class BrowserStorage<E> {
  get(key: BrowserStorageKeys, defaultData: E): E {
    try {
      const item = localStorage.getItem(key);
      if (item === null) {
        return defaultData;
      }

      return JSON.parse(item);
    } catch (error) {
      return defaultData;
    }
  }

  set(key: BrowserStorageKeys, data: E): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  clear(): void {
    localStorage.clear();
  }
}

interface NonMemberAuthData {
  phone: string;
  cert_number: string;
  token: string;
  expired_at: Date | null;
}

export class NonMemberAuthStorage {
  private key = 'NON-MEMBER-AUTH';
  storage: BrowserStorage<NonMemberAuthData>;

  constructor() {
    this.storage = new BrowserStorage();
  }

  get() {
    return this.storage.get(this.key, { phone: '', cert_number: '', token: '', expired_at: null });
  }

  set(data: NonMemberAuthData) {
    this.storage.set(this.key, data);
  }

  clear() {
    this.storage.set(this.key, { phone: '', cert_number: '', token: '', expired_at: null });
  }

  isAvailable() {
    const { phone, cert_number, token, expired_at } = this.get();

    if (!expired_at) return false;

    const expiredAt = new Date(expired_at);
    if (new Date() >= expiredAt) return false;

    return !!(token && phone && cert_number && expired_at);
  }
}
